import { css } from '@mui/material';

import type { ThemeOptions } from '@mui/material';
import type { LinkProps } from './types';

export const linkThemes: ThemeOptions['components'] = {
  MuiLink: {
    styleOverrides: {},
    variants: [
      {
        props: { size: 'xs' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['label/regular/xs']}
        `,
      },
      {
        props: { size: 'sm' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['label/regular/sm']}

          & > svg {
            font-size: 14px;
          }
        `,
      },
      {
        props: { size: 'md' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['label/regular/md']}

          & > svg {
            font-size: 16px;
          }
        `,
      },
      {
        props: { size: 'lg' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['label/regular/lg']}

          & > svg {
            font-size: 18px;
          }
        `,
      },
      {
        props: { size: 'xl' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['heading/semibold/2xl']}

          & > svg {
            font-size: 20px;
          }
        `,
      },
      {
        props: { size: 'xxl' } as LinkProps,
        style: ({ theme }) => css`
          ${theme.typography['heading/semibold/3xl']}

          & > svg {
            font-size: 20px;
          }
        `,
      },
    ],
  },
};
